/**
 * URL-safe slug helpers.
 *
 * - toSlug(str)              — generic kebab-case slug (Latin + Arabic)
 * - buildProductSlug(p)      — ouedkniss-style: {cat}-{brand}-{ville}-{title}-d{numericId}
 * - parseNumericIdFromSlug() — extracts the numeric id from a product slug
 */

export const toSlug = (title) =>
  String(title || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' et ')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9؀-ۿ-]/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '') || 'article';

const pickAddress = (addr) => {
  if (!addr) return {};
  if (Array.isArray(addr)) return addr[0] || {};
  return addr;
};

export const buildProductSlug = (p) => {
  if (!p) return '';
  const numericId = p.numericId ?? p.numeric_id;
  // Fallback for old products without numericId — keep legacy URL.
  if (!numericId) {
    const id = p._id || p.id;
    return id ? `article/${id}/${toSlug(p.title)}` : '';
  }

  const addr = pickAddress(p.address);
  const ville = addr.city || addr.wilaya || addr.state || '';

  const cat = p.catagory ?? p.category;       // legacy formatProduct uses 'catagory'
  const parts = [cat, p.brand, ville, p.title]
    .map(toSlug)
    .filter((s) => s && s !== 'article');

  const trimmed = parts.map((part, i) =>
    part.slice(0, i === parts.length - 1 ? 60 : 40)
  );
  const base = trimmed.join('-').replace(/-+/g, '-');

  return `${base}-d${numericId}`;
};

export const parseNumericIdFromSlug = (slug) => {
  if (!slug) return null;
  const m = String(slug).match(/-d(\d+)$/);
  return m ? Number(m[1]) : null;
};
